export const ICREDUCER = (state = {
    heading_order: { selected_heading:'', headings: [] },
    mappings: { child: '', parent: '', cpg_map: {} },
    config_1: { name: '', ic_code: '', analysis: null, filters: [], secondary_tabs: [], type: ["Value", "Volume", "PCE", "PCC", "Price"], currencies: ['USD','EURO','USD Constant','EURO Constant','LCU'], base_currency: '' },
    config_2: { mappings: {}, calc_exc_fields: [], channel_contains: [], drill_downs: [], heading_order: [], currency: [] },
    selectedValues: {},
    configList: [],
    ic_to_update: '',
    update_step: 1,
    addingConfigStatus: false,
    files_to_publish: [],
    data_to_download: {
      data: [],
      ic_code: '',
      type: '',
      channel: ''
    }
  }, action) => {
  switch(action.type) {
    case 'SET_CONFIG_1':
      return {
        ...state,
        config_1: action.data
      };
    case 'SET_CONFIG_2':
      return {
        ...state,
        config_2: action.data
      };
    case 'SET_SELECTED_VALUES':
      return {
        ...state,
        selectedValues: action.data
      };
    case 'SET_HEADINGS':
      state.heading_order.headings = action.data;  
      return {
        ...state
      };
    case 'SET_SELECTED_HEADING':
      state.heading_order.selected_heading = action.data; 
      return {
        ...state
      };
    case 'SET_MAPPINGS':
      state.mappings.cpg_map = action.data;
      return {
        ...state
      };
    case 'SET_MAPPING_CHILD':
      state.mappings.child = action.data;
      return {
        ...state
      };
    case 'SET_MAPPING_PARENT':
      state.mappings.parent = action.data;
      return {
        ...state
      };
    case 'SET_CONFIG_LIST':
      return {
        ...state,
        configList: action.data
      };
    case 'CHANGE_IC_TO_UPDATE':
      return {
        ...state,
        ic_to_update: action.data
      };
    case 'UPDATE_STEP':
      return {
        ...state,
        update_step: action.data
      };
    case 'SET_FILTER_LIST':
      state.config_1.filters = action.data;
      return {
        ...state
      };
    case 'SET_SEC_TABS':
      state.config_1.secondary_tabs = action.data;
      return {
        ...state
      };
    case 'ADDING_CONFIG_STATUS':
      return {
        ...state,
        addingConfigStatus: action.data
      };
    case 'SET_FILES_TO_PUBLISH':
      state.files_to_publish = action.data;
      return {
        ...state
      };
    case 'SET_DATA_TO_DOWNLOAD_DATA':
      state.data_to_download.data = action.data;
      return {
        ...state
      };
    case 'SET_DATA_TO_DOWNLOAD_IC':
      state.data_to_download.ic_code = action.data;
      return {
        ...state
      };
    case 'SET_DATA_TO_DOWNLOAD_TYPE':
      state.data_to_download.type = action.data;
      return {
        ...state
      };
    case 'SET_DATA_TO_DOWNLOAD_CHANNEL':
      state.data_to_download.channel = action.data;
      return {
        ...state
      };
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/redux/reducers/IC/ICReducer.js